module.exports = __webpack_public_path__ + "media/images/lb/043-2832422e69836f2d4270a9257de0d367.svg";